import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { NewsPost } from '../../models/news-post';
import { NewsPostDetailFormValues } from '../models/news-post-detail-form-values';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';
import { newsPostDetailRequestSelector } from './news-post-detail-selector';

export const NEWS_POST_DETAIL_FETCH = 'NEWS_POST_DETAIL_FETCH';
export const NEWS_POST_DETAIL_RESET = 'NEWS_POST_DETAIL_RESET';
export const NEWS_POST_DETAIL_CREATE = 'NEWS_POST_DETAIL_CREATE';
export const NEWS_POST_DETAIL_UPDATE = 'NEWS_POST_DETAIL_UPDATE';
export const NEWS_POST_DETAIL_RECEIVE = 'NEWS_POST_DETAIL_RECEIVE';
export const NEWS_POST_DETAIL_ERROR = 'NEWS_POST_DETAIL_ERROR';

const receiveNewsPostDetail = (newsPost: NewsPost) => {
    return {
        type: NEWS_POST_DETAIL_RECEIVE,
        newsPost,
    };
};

export const resetNewsPostDetail = () => {
    return {
        type: NEWS_POST_DETAIL_RESET,
    };
};

export const fetchNewsPostDetail = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: NEWS_POST_DETAIL_FETCH });
        const response = await api.contentManagement.NewsPost.NewsPostDetail.getNewsPostDetail(id);
        if (response.success) {
            dispatch(receiveNewsPostDetail(response.result));
        } else {
            dispatch({ type: NEWS_POST_DETAIL_ERROR });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveNewsPostDetail = (newsPostValues: NewsPostDetailFormValues, file?: File) => {
    return async (dispatch: ReduxDispatch, getState: () => AppState, { api }: { api: Api }) => {
        const newsPost = newsPostDetailRequestSelector(newsPostValues)(getState());

        let response: ApiResult<NewsPost> | null = null;
        if (newsPost.id) {
            dispatch({ type: NEWS_POST_DETAIL_UPDATE });
            response = await api.contentManagement.NewsPost.NewsPostDetail.updateNewsPostDetail(newsPost);
        } else {
            dispatch({ type: NEWS_POST_DETAIL_CREATE });
            response = await api.contentManagement.NewsPost.NewsPostDetail.createNewsPostDetail(newsPost);
        }

        if (response.success) {
            dispatch(receiveNewsPostDetail(response.result));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.newsPostSaved')));
        } else {
            dispatch({ type: NEWS_POST_DETAIL_ERROR });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
